/**
 * @description traigo la fecha actual que necesita la fn selectDay para redireccionar en el calendario
 * @returns {*} {"dateString": "2024-06-27", "day": 27, "month": 6, "timestamp": 1719499627726, "year": 2024}
 */
export const getCurrentDateObject = () => {
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() + 1 // Los meses en JavaScript son 0-indexados
    const day = currentDate.getDate()
    const timestamp = currentDate.getTime()
    const dateString = currentDate.toISOString().split('T')[0] // Formato YYYY-MM-DD

    return {
        dateString,
        day,
        month,
        timestamp,
        year,
    }
}

/**
 * @description formatea la fecha de esta forma: "jueves 27 de junio"
 * @param date
 * @returns {string} `${dayOfWeek} ${day} de ${month} | ''`
 */
export const formatDate = (date: Date) => {
    const daysOfWeek = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
    const monthsOfYear = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    const dayOfWeek = daysOfWeek[date.getDay()]
    const day = date.getDate()
    const month = monthsOfYear[date.getMonth()]

    if (dayOfWeek && day && month ) return `${dayOfWeek} ${day} de ${month}`
    else ''
}

/**
 * @description convierte un Date a 'YYYY-MM-DD' usando componentes locales (sin pasar por UTC),
 * para que el round-trip con isoDateStringToDate no sufra corrimientos de huso horario.
 */
export const dateToISODateString = (date: Date): string => {
    const pad = (num: number) => num.toString().padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/**
 * @description parsea 'YYYY-MM-DD' (o un ISO más largo) a un Date en horario local,
 * evitando el corrimiento de día que da `new Date('YYYY-MM-DD')` (lo interpreta como UTC).
 */
export const isoDateStringToDate = (value?: string): Date | null => {
    if (!value) return null
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
    if (!match) return null
    const [, year, month, day] = match
    return new Date(Number(year), Number(month) - 1, Number(day))
}

/**
 * @description formatea un Date como 'DD/MM/YYYY'
 */
export const dateToDisplayString = (date: Date): string => {
    const pad = (num: number) => num.toString().padStart(2, '0')
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
}

export const parseDateCardHistory = (dateString: string): string => {
    const date = new Date(dateString);

    const pad = (num: number) => num.toString().padStart(2, '0')

    const day = pad(date.getDate())
    const month = pad(date.getMonth() + 1)
    const year = date.getFullYear()

    let hours = date.getHours()
    const minutes = pad(date.getMinutes())
    const ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12
    const formattedHours = pad(hours)

    return `${day}/${month}/${year}; ${formattedHours}:${minutes}${ampm}`
}
